import Configuration from './sc/configuration/Configuration';
import Roles from './sc/roles/Roles';
import Mships from './sc/mships/Mships';
import Facilities from './sc/facilities/Facilities';
import FacilitySets from './sc/facilitySets/FacilitySets';
import FacilitySet from './sc/facilitySets/FacilitySet';
import Report from './sc/Report';
import Rates from './sc/rates/Rates';
import Bookings from './sc/bookings/Bookings';
import BusySchedules from './sc/busySchedules/BusySchedules';
import BusySchedule from './sc/busySchedules/BusySchedule';
import FreeSchedules from './sc/freeSchedules/FreeSchedules';
import Devices from './sc/devices/Devices';
import Payments from './sc/payments/Payments';
import Groups from './sc/groups/Groups';
import Activities from './sc/activities/Activities';
import Bonos from './sc/bonos/Bonos';
import Bono from './sc/bonos/Bono';
import Files from './sc/Files';
import Remittences from './sc/remittences/Remittences';
import Remittence from './sc/remittences/Remittence';
import GenerateRemittence from './sc/remittences/GenerateRemittence';
import FileCSV from './sc/filesCSV/FileCSV';
import Teachers from './sc/teachers/Teachers';
import Teacher from './sc/teachers/Teacher';
import BookingSchedules from './sc/bookingSchedules/BookingSchedules';
import BookingSchedule from './sc/bookingSchedules/BookingSchedule';
import Restrictions from './sc/restrictions/Restrictions';
import Restriction from './sc/restrictions/Restriction';
import Reports from './sc/reports/Reports';
import SCMessages from './sc/messages/SCMessages';
import SalePointTickets from './sc/tickets/SalePointTickets';
import SalePointPage from './sc/salePoint/SalePointPage';
import CapacityMonitorPage from './sc/capacityMonitor/CapacityMonitorPage';
import Students from './sc/students/Students';
import Events from './sc/events/Events';
import NoSubscription from './sc/noSubscription/NoSubscription';
import Login from './public/Login';
import Register from './public/Register';
import AcceptConditions from './public/AcceptConditions';
import ConfirmEmail from './public/ConfirmEmail';
import RecoverPassword from './public/RecoverPassword';
import Privacy from './public/Privacy';
import Account from './public/Account';
import Apis from './public/apis/Apis';
import UnderConstruction from './public/UnderConstruction';
import Timetable from './public/timetable/Timetable';
import Booked from './public/booked/Booked';
import TPVResult from './public/tpv/TPVResult';
import Booking from './public/booking/Booking';
import SCProfile from './public/scProfile/SCProfile';
import AbonoList from './public/buyAbono/AbonoList';
import BuyAbono from './public/buyAbono/BuyAbono';
import BonoList from './public/buyBono/BonoList';
import BuyBono from './public/buyBono/BuyBono';
import ActivityPublic from './public/activity/Activity';
import EventPublic from './public/event/Event';
import Widget from './public/widget/Widget';
import Subscription from './sc/subscription/Subscription';
import Plans from './sc/subscription/Plans';
import Home from './common/Home';
import Contact from './public/Contact';
import SCDocuments from './sc/documents/SCDocuments';
import SCContact from './public/scProfile/SCContact';
import SmartCourt from './public/Smartcourt';
import Discounts from './sc/discounts/Discounts';
import TPVSwitcher from './public/tpv/TPVSwitcher';
import SCStats from './sc/reports/SCStats';
import Game from './public/game/Game';
import GameConfirmation from './public/game/GameConfirmation';
import GameRegister from './public/game/GameRegister';
import GameSC from './sc/game/GameSC';
import AddPlayerSC from './sc/game/AddPlayerSC';
import Wall from './public/Wall';

// Una ruta no es más que un objeto que contiene los siguientes parámetros:
//     - id: Usado para la identificación única de la ruta (obligatorio).
//     - path: URL asociada al ID de la ruta (obligatorio).
//     - role: El rol puede ser SPORTCENTER. El rol obliga
//         a que una ruta protegida con el parámetro "protected" solo pueda ser accedida
//         por usuarios con dicho rol. Por defecto no usa ningún rol (no obligatorio).
//     - protected: Su valor puede ser true (bloquea la ruta al usuario no conectado) y
//         false (no bloquea la ruta a ningún usuario). Por defecto es false (no obligatorio).
//     - header: Su valor puede ser true (activa el header en dicha ruta) y
//         false (desactiva el header en la ruta). Por defecto es true (no obligatorio).
//     - footer: Su valor puede ser true (activa el footer en dicha ruta) y
//         false (desactiva el footer en la ruta). Por defecto es true (no obligatorio).
//     - fullScreen: Su valor puede ser true (pagina fullScreen sin padding ni margenes) y
//         false (pagina con padding y margenes). Por defecto es false (no obligatorio).
//     - component: Nombre del componente que se va a visualizar cuando el se acceda a la
//         ruta dada por el parámetro "path" (obligatorio).
//     - exact: Booleano para definir si queremos que la ruta tiene o no que ser exacta para renderizar
//         un componente.

export const paths = [
    // ----------------
    //     COMMON ROUTES (for example /home)
    // ----------------
    {
        id: 'home',
        path: '/home',
        component: Home,
    },

    // ----------------
    //     PUBLIC
    // ----------------
    {
        id: 'root',
        path: '/',
        protected: false,
        header: false,
        footer: false,
        component: Login,
    },
    {
        id: 'smartcourt',
        path: '/smartcourt',
        protected: false,
        component: SmartCourt,
    },
    {
        id: 'contact',
        path: '/contact',
        protected: false,
        component: Contact,
    },
    {
        id: 'wall',
        path: '/wall',
        protected: false,
        component: Wall,
    },
    {
        id: 'login',
        path: '/login',
        protected: false,
        header: false,
        footer: false,
        component: Login,
    },
    {
        id: 'signup',
        path: '/signup',
        protected: false,
        header: false,
        component: Register,
    },
    {
        id: 'recoverPassword',
        path: '/recover',
        protected: false,
        header: false,
        component: RecoverPassword,
    },
    {
        id: 'confirmEmail',
        path: '/email/activation',
        protected: false,
        component: ConfirmEmail,
    },
    {
        id: 'acceptConditions',
        path: '/privacy/confirmation/:id/:signature',
        protected: false,
        component: AcceptConditions,
    },
    {
        id: 'privacy',
        path: '/privacy',
        protected: false,
        component: Privacy,
    },
    // Disponibilidad: página del centro protegida (con los roles encendidos
    // exige booking.view, ver `routePermissions`).
    {
        id: 'timetable',
        role: 'SPORTCENTER',
        path: '/timetable',
        protected: true,
        component: Timetable,
    },
    {
        id: 'apis',
        path: '/apis',
        component: Apis,
    },
    {
        id: 'tpvSwitcher',
        path: '/tpvs/:id',
        header: false,
        footer: false,
        fullScreen: true,
        component: TPVSwitcher,
    },
    {
        id: 'tpvResult',
        path: '/tpvs/:id/result',
        header: false,
        footer: false,
        fullScreen: true,
        component: TPVResult,
    },
    {
        id: 'activityPublic',
        path: '/public/activities/:id',
        component: ActivityPublic,
    },
    {
        id: 'abonoList',
        path: '/:id/groups',
        component: AbonoList,
    },
    {
        id: 'wall',
        path: '/wall',
        component: Wall,
    },
    {
        id: 'scProfile',
        path: '/:id/profile',
        component: SCProfile,
    },
    {
        id: 'scDocuments',
        path: '/:id/documents',
        component: SCDocuments,
    },
    {
        id: 'scContact',
        path: '/:id/contact',
        component: SCContact,
    },
    {
        id: 'bonoList',
        path: '/:id/bonos',
        component: BonoList,
    },
    {
        id: 'booked',
        path: '/bookings/:id',
        component: Booked,
    },
    {
        id: 'gameRegister',
        path: '/games/:id/register',
        component: GameRegister,
    },
    {
        id: 'gameConfirmation',
        path: '/games/:id/confirmation',
        component: GameConfirmation,
    },
    {
        id: 'scGame',
        role: 'SPORTCENTER',
        protected: true,
        path: '/games/:id/sc',
        component: GameSC,
    },
    {
        id: 'addPlayerToGame',
        role: 'SPORTCENTER',
        protected: true,
        path: '/games/:id/addPlayer',
        component: AddPlayerSC,
    },
    {
        id: 'game',
        path: '/games/:id',
        component: Game,
    },
    // Note: eventPublic route moved after eventsDetail in SPORTS CENTERS section
    // to ensure protected route takes precedence for sport center admins
    {
        id: 'widget',
        path: '/:id/widget',
        header: false,
        footer: false,
        component: Widget,
    },
    {
        id: 'buyBono',
        path: '/:idSC/bonos/:id/purchase',
        component: BuyBono,
    },
    {
        id: 'buyAbono',
        path: '/:idSc/groups/:idGroup/purchases',
        component: BuyAbono,
    },

    // ----------------------
    //     SPORTS CENTERS
    // ----------------------
    {
        id: 'scConfigurationTab',
        role: 'SPORTCENTER',
        path: '/configurations/:tab',
        protected: true,
        component: Configuration,
    },
    {
        id: 'scConfiguration',
        role: 'SPORTCENTER',
        path: '/configurations',
        protected: true,
        component: Configuration,
    },
    {
        id: 'scRoles',
        role: 'SPORTCENTER',
        path: '/roles',
        protected: true,
        component: Roles,
    },
    {
        id: 'freeSchedules',
        role: 'SPORTCENTER',
        path: '/frees/schedules',
        protected: true,
        component: FreeSchedules,
    },
    {
        id: 'freeSchedule',
        role: 'SPORTCENTER',
        path: '/frees/schedules/:id',
        protected: true,
        component: FreeSchedules,
    },
    {
        id: 'remittences',
        role: 'SPORTCENTER',
        path: '/remittences',
        protected: true,
        component: Remittences,
    },
    {
        id: 'genRemittences',
        role: 'SPORTCENTER',
        path: '/remittences/generate',
        protected: true,
        component: GenerateRemittence,
    },
    {
        id: 'remittence',
        role: 'SPORTCENTER',
        path: '/remittences/:id',
        protected: true,
        component: Remittence,
    },
    {
        id: 'facilitySets',
        role: 'SPORTCENTER',
        path: '/facilitySets',
        protected: true,
        component: FacilitySets,
    },
    {
        id: 'facilitySet',
        role: 'SPORTCENTER',
        path: '/facilitySets/:id',
        protected: true,
        component: FacilitySet,
    },
    {
        id: 'facilitySetCreate',
        role: 'SPORTCENTER',
        path: '/facilitySets/create',
        protected: true,
        component: FacilitySet,
    },
    {
        id: 'facilities',
        role: 'SPORTCENTER',
        path: '/facilities',
        protected: true,
        component: Facilities,
    },
    {
        id: 'facility',
        role: 'SPORTCENTER',
        path: '/facilities/:id',
        protected: true,
        component: Facilities,
    },
    {
        id: 'devices',
        role: 'SPORTCENTER',
        path: '/devices',
        protected: true,
        component: Devices,
    },
    {
        id: 'device',
        role: 'SPORTCENTER',
        path: '/devices/:id',
        protected: true,
        component: Devices,
    },
    {
        id: 'deviceAuthorizations',
        role: 'SPORTCENTER',
        path: '/devices/:id/authorizations',
        protected: true,
        component: Devices,
    },
    {
        id: 'deviceAccesses',
        role: 'SPORTCENTER',
        path: '/devices/:id/accesses',
        protected: true,
        component: Devices,
    },
    {
        id: 'mships',
        role: 'SPORTCENTER',
        path: '/mships',
        protected: true,
        component: Mships,
    },
    {
        id: 'mship',
        role: 'SPORTCENTER',
        path: '/mships/:id',
        protected: true,
        component: Mships,
    },
    {
        id: 'mshipTab',
        role: 'SPORTCENTER',
        path: '/mships/:id/:tab',
        protected: true,
        component: Mships,
    },
    {
        id: 'booking',
        role: 'SPORTCENTER',
        path: '/:id/booking',
        protected: true,
        component: Booking,
    },
    {
        id: 'bookings',
        role: 'SPORTCENTER',
        path: '/bookings',
        protected: true,
        component: Bookings,
    },
    {
        id: 'busySchedules',
        role: 'SPORTCENTER',
        path: '/busy/schedules',
        protected: true,
        component: BusySchedules,
    },
    {
        id: 'busySchedule',
        role: 'SPORTCENTER',
        path: '/busy/schedules/:id',
        protected: true,
        component: BusySchedule,
    },
    {
        id: 'payments',
        role: 'SPORTCENTER',
        path: '/payments',
        protected: true,
        component: Payments,
    },
    {
        id: 'payment',
        role: 'SPORTCENTER',
        path: '/payments/:id',
        protected: true,
        component: Payments,
    },
    {
        id: 'activities',
        role: 'SPORTCENTER',
        path: '/activities',
        protected: true,
        component: Activities,
    },
    {
        id: 'activityDetailTab',
        role: 'SPORTCENTER',
        path: '/activities/:id/:tab',
        protected: true,
        component: Activities,
    },
    {
        id: 'activity',
        role: 'SPORTCENTER',
        path: '/activities/:id',
        protected: true,
        component: Activities,
    },
    {
        id: 'groups',
        role: 'SPORTCENTER',
        path: '/groups',
        protected: true,
        component: Groups,
    },
    {
        id: 'groupDetailTab',
        role: 'SPORTCENTER',
        path: '/groups/:id/:tab',
        protected: true,
        component: Groups,
    },
    {
        id: 'group',
        role: 'SPORTCENTER',
        path: '/groups/:id',
        protected: true,
        component: Groups,
    },
    {
        id: 'rates',
        role: 'SPORTCENTER',
        path: '/rates',
        protected: true,
        component: Rates,
    },
    {
        id: 'report',
        role: 'SPORTCENTER',
        path: '/reports/:id',
        protected: true,
        component: Report,
    },
    {
        id: 'files',
        role: 'SPORTCENTER',
        path: '/files',
        protected: true,
        component: Files,
    },
    {
        id: 'bonos',
        role: 'SPORTCENTER',
        path: '/bonos',
        protected: true,
        component: Bonos,
    },
    {
        id: 'bono',
        role: 'SPORTCENTER',
        path: '/bonos/:id',
        protected: true,
        component: Bono,
    },
    {
        id: 'bonoTab',
        role: 'SPORTCENTER',
        path: '/bonos/:id/:tab',
        protected: true,
        component: Bono,
    },
    {
        id: 'fileCSV',
        role: 'SPORTCENTER',
        path: '/files/csvs/:id',
        protected: true,
        component: FileCSV,
    },
    {
        id: 'bookingSchedules',
        role: 'SPORTCENTER',
        path: '/booking/schedules',
        protected: true,
        component: BookingSchedules,
    },
    {
        id: 'bookingSchedule',
        role: 'SPORTCENTER',
        path: '/booking/schedules/:id',
        protected: true,
        component: BookingSchedule,
    },
    {
        id: 'restrictions',
        role: 'SPORTCENTER',
        path: '/restrictions',
        protected: true,
        component: Restrictions,
    },
    {
        id: 'restriction',
        role: 'SPORTCENTER',
        path: '/restrictions/:id',
        protected: true,
        component: Restriction,
    },
    {
        id: 'teachers',
        role: 'SPORTCENTER',
        path: '/teachers',
        protected: true,
        component: Teachers,
    },
    {
        id: 'teacher',
        role: 'SPORTCENTER',
        path: '/teachers/:id',
        protected: true,
        component: Teacher,
    },
    {
        id: 'teacherClasses',
        role: 'SPORTCENTER',
        path: '/teachers/:id/classes',
        protected: true,
        component: Teacher,
    },
    {
        id: 'scMessages',
        role: 'SPORTCENTER',
        path: '/messages',
        protected: true,
        component: SCMessages,
    },
    {
        id: 'account',
        role: 'SPORTCENTER',
        path: '/account',
        protected: true,
        component: Account,
    },
    {
        id: 'scReports',
        role: 'SPORTCENTER',
        path: '/reports',
        protected: true,
        component: Reports,
    },
    {
        id: 'scTickets',
        role: 'SPORTCENTER',
        path: '/tickets',
        protected: true,
        component: SalePointTickets,
    },
    {
        id: 'students',
        role: 'SPORTCENTER',
        path: '/students',
        protected: true,
        component: Students,
    },
    {
        id: 'events',
        role: 'SPORTCENTER',
        path: '/events',
        protected: true,
        component: Events,
    },
    {
        id: 'eventsDetailTab',
        role: 'SPORTCENTER',
        path: '/events/:id/:tab',
        protected: true,
        component: Events,
    },
    {
        id: 'eventsDetail',
        role: 'SPORTCENTER',
        path: '/events/:id',
        protected: true,
        component: Events,
    },
    // Public event route - placed after protected eventsDetail so sport center admins see Events component
    {
        id: 'eventPublic',
        path: '/events/:id',
        component: EventPublic,
    },
    {
        id: 'help',
        role: 'SPORTCENTER',
        path: '/help',
        protected: true,
        component: Contact,
    },
    {
        id: 'waitingLists',
        role: 'SPORTCENTER',
        path: '/waitingLists',
        protected: true,
        component: UnderConstruction,
    },
    {
        id: 'subscriptions',
        role: 'SPORTCENTER',
        path: '/subscriptions',
        protected: true,
        component: Subscription,
    },
    {
        id: 'subscriptionPlans',
        role: 'SPORTCENTER',
        path: '/subscriptions/plans',
        protected: true,
        component: Plans,
    },
    {
        id: 'noSubscription',
        role: 'SPORTCENTER',
        path: '/NoSubscription',
        protected: true,
        component: NoSubscription,
    },
    {
        id: 'discounts',
        role: 'SPORTCENTER',
        path: '/discounts',
        protected: true,
        component: Discounts,
    },
    {
        id: 'scStats',
        role: 'SPORTCENTER',
        path: '/stats',
        protected: true,
        component: SCStats,
    },
    {
        id: 'salePoint',
        role: 'SPORTCENTER',
        path: '/sale-point',
        protected: true,
        component: SalePointPage,
    },
    {
        id: 'capacityMonitor',
        role: 'SPORTCENTER',
        path: '/capacity-monitor',
        protected: true,
        component: CapacityMonitorPage,
    },
    {
        id: 'competitions',
        role: 'SPORTCENTER',
        path: '/competitions',
        protected: true,
    },
    {
        id: 'charges',
        role: 'SPORTCENTER',
        path: '/charges',
        protected: true,
    },
    {
        id: 'transactions',
        role: 'SPORTCENTER',
        path: '/transactions',
        protected: true,
    },

    // ---------------------
    //    PÁGINA NO ENCONTRADA - Redirigir a login
    // ---------------------
    {
        id: 'page404',
        path: '*',
        component: Login,
        header: false,
        footer: false,
        exact: false,
    },
] as const;

/**
 * Method to get url path using id key of route.
 */
export const getPath = (
    idPath: (typeof paths)[number]['id'],
    params: Record<string, unknown> = {},
) => {
    const pathObj = paths.find((path: any) => path.id === idPath);

    if (pathObj) {
        let finalPath: string = pathObj.path;

        if (params) {
            Object.keys(params).forEach((key: any) => {
                const value = params[key];
                // Skip undefined/null values to avoid replacing with invalid data
                if (value !== null && value !== undefined) {
                    finalPath = finalPath.replace(`:${key}`, String(value));
                }
            });
        }
        return finalPath;
    }

    // In case the path couldn't be found, we return a base path to avoid crashes
    return '/';
};
